import { Block } from 'components/Block'
import { ContactLead } from 'components/content/contact/contactLead/ContactLead'
import { SecurityHero } from 'components/content/security/SecurityHero/SecurityHero'
import { SecurityInfoBlock } from 'components/content/security/SecurityInfoBlock/SecurityInfoBlock'
import { Footer } from 'components/footer/Footer'
import { TopNavigationLandingPage } from 'components/header/topNavigationLandingPage/TopNavigationLandingPage'
import { Layout } from 'components/layout/Layout'
import { PageMeta } from 'components/PageMeta'
import { PageTitle } from 'components/PageTitle'
import { Spacer } from 'components/spacer/Spacer'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t } = useTranslation('security')

  return (
    <Layout
      header={<TopNavigationLandingPage variant="general-info" />}
      footer={<Footer variant="estate-planning" />}
    >
      <PageTitle title={t('security.meta_desc')} />
      <PageMeta description={t('security.meta_desc')} image="/images/preview/security.png" />

      <SecurityHero />

      <Spacer size={[2, 8]} />

      <SecurityInfoBlock />

      <Block>
        <ContactLead css={{ marginLeft: 'auto' }} />
      </Block>

      <Spacer size={[3, 6]} />
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: { ...(await getIntlProps(ctx, 'security')) },
  }
}
